module.exports = __webpack_public_path__ + "img/how-to-play_game_splash.b5f615f2.jpg";